import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-research-admins',
  templateUrl: './research-admins.component.html',
  standalone: false
})
export class ResearchAdminsComponent implements OnInit {
  admins: any[] = [];
  loading = false;
  error = '';
  inviting = false;
  inviteEmail = '';

  constructor(private http: HttpClient, private authService: AuthService) {}

  get currentUserEmail(): string { return this.authService.currentUserValue?.email ?? ''; }

  get headers() {
    const clientId = this.authService.currentClientValue?.client_id?.toString() || '';
    return new HttpHeaders({ 'Content-Type': 'application/json', 'client_id': clientId });
  }

  get base() { return `${environment.api}research/`; }

  ngOnInit(): void { this.load(); }

  load() {
    this.loading = true;
    this.http.get<any>(`${this.base}admin-users`, { headers: this.headers }).subscribe({
      next: (res) => { this.admins = res.admins; this.loading = false; },
      error: (err) => { this.error = err.message || 'Error'; this.loading = false; }
    });
  }

  invite() {
    if (!this.inviteEmail.trim()) return;
    this.inviting = true;
    this.http.post<any>(`${this.base}admin-users`, { email: this.inviteEmail }, { headers: this.headers }).subscribe({
      next: () => { this.inviteEmail = ''; this.inviting = false; this.load(); },
      error: (err) => { this.error = err.message || 'Error'; this.inviting = false; }
    });
  }

  updateStatus(id: number, status: string) {
    this.http.patch<any>(`${this.base}admin-users/${id}`, { status }, { headers: this.headers }).subscribe({
      next: () => this.load(),
      error: (err) => { this.error = err.message || 'Error'; }
    });
  }
}
